import VideoFullWidth from './component.jsx'
export default VideoFullWidth
